import React from 'react';
import Hero, { type HeroProps } from '../../../react4xp/components/Hero'

function HeroPart (props: HeroProps) {
  return (
    <Hero {...props} />
  )
}

export default (props: HeroProps) => <HeroPart {...props} />
